import deleteObject from '../../../Common/delete';

export let deleteMaintenanceByType = async(props, user) => {
    let alerts =  {
        open: true,
        severity: 'error',
        message: "Error when deleting. No record has been selected to delete. Contact the website administrator for more details."
    };
    
    if(props != null && (props.id != null && props.id != undefined && props.id != "")) {
        switch(props.code) {
            case process.env.REACT_APP_MANAGEMENT_EGT:
                let energetic = await deleteObject(null, "certificates/energeticos/delete/", props.id);
                alerts = setAlerts(energetic);
                break;
            case process.env.REACT_APP_MANAGEMENT_EXT:
                let exeption = await deleteObject(null, "certificates/retenciones/delete/", props.id);
                alerts = setAlerts(exeption);
                break;
            case process.env.REACT_APP_MANAGEMENT_RT:
                let index = await deleteObject(null, "medidas/indices/delete/", props.id);
                alerts = setAlerts(index);
                break;
        }
    }
    
    return alerts;
}

let setAlerts = (values) => {
	let response = '';
	if (values.status === 200) {
        response = {
            open: true,
            severity: 'success',
            message: values.data.mensaje
        };
    } else {
        response = {
            open: true,
            severity: 'error',
            message: values.data.mensaje
        };
    }
	
	return response
}